import React from 'react';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {DataTableLocalization, Translate} from "../../../config/Translate";
import axios from "axios";
import {defaultVariabls} from "../../../config/index";
import {connect} from "trim-redux";
import MaterialTable from "material-table";
import {tableIcons} from "../../../config/design/TableIcons";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import moment from "jalali-moment";
import {TableCount, TablePage} from "../../../config/Permissions";
import Container from "@material-ui/core/Container/Container";
import Typography from "@material-ui/core/Typography/Typography";
import AppCardLoaderTable from "../../components/Skeletons/AppCardLoaderTable";
import Button from "@material-ui/core/Button/Button";
import VisibilityRoundedIcon from '@material-ui/icons/VisibilityRounded';
import IconButton from "@material-ui/core/IconButton/IconButton";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import ChevronLeftRoundedIcon from '@material-ui/icons/ChevronLeftRounded';

class Tickets extends React.Component {
    constructor(props) {
        super(props)
        this.tableRef = React.createRef()
    }
    classes = this.props.classes;
    state = {
        columns: [
            { title: Translate.ticket_sender,
                field: 'starter',
                filterPlaceholder: Translate.search
            },
            { title: Translate.ticket_receiver,
                field: 'receiver',
                filterPlaceholder: Translate.search
            },
            { title: Translate.subject,
                field: 'subject',
                filterPlaceholder: Translate.search
            },
            { title: Translate.requestType,
                field: 'target',
                render: rowData =>(
                    <>
                        <Typography>
                            {rowData.type === "system" ?
                                Translate.supportRequestFromDepartment :
                                Translate.supportRequestForProduct
                            }
                        </Typography>
                        <Typography style={{fontSize:11,color:"#777",marginTop:5}}>
                            {rowData.type === "system" ?
                                "(" + Translate.department +" "+rowData.target.name + ")" :
                                "(" + rowData.target.product.name + ")"
                            }
                        </Typography>
                    </>
                )
            },
            { title: Translate.priority,
                field: 'priority',
                filterPlaceholder: Translate.search
            },
            { title: Translate.ticket_edited_at,editable: 'never',filtering: false, field: 'lastUpdate'},
            {
                title: Translate.action,
                editable: 'never',
                field: 'action',
                render: rowData =>(
                    <>
                        <Button
                            variant="outlined"
                            size="small"
                            style={{marginBottom:5}}
                            startIcon={
                                <ChevronLeftRoundedIcon/>
                            }
                            onClick={() => this.props.history.push(`/manage/ticket/${rowData.id}`)}
                        >
                            {Translate.view}
                        </Button>
                    </>
                )
            }
        ],

        data: [],
        loading:false,
        ChangeLoader:false,
        manage:this.props.manage,
    };
    componentDidMount(){
        this.loadData();
    }
    loadData(){
        this.tableRef.current && this.tableRef.current.onQueryChange()

    }
    onDelete(id,hasNotif = true) {
        let data = new FormData();
        data.append('id', id);
        let loginToken = localStorage.getItem('ACT');

        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/ticket/delete`, data, config)
            .then(response => {
                if(hasNotif){
                    this.props.enqueueSnackbar(Translate.deleteTicket, {
                        variant: 'success',
                    });
                }
                return true
            })
            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(Translate.deleteTicketFailed, {
                    variant: 'error',
                });
                this.loadData();
                return false
            });
    }

    render(){
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        return (
            <>
                {
                this.state.loading ? <AppCardLoaderTable/> :
                    <Container maxWidth="xl">
                        <MaterialTable
                            tableRef={this.tableRef}
                            icons={tableIcons}
                            title={" "}
                            localization={DataTableLocalization}
                            columns={this.state.columns}
                            data={query =>
                                new Promise((resolve, reject) => {
                                    axios.get(`${defaultVariabls.url}/${this.props.manage ? "tickets" : "my-tickets"}/quickView?page=${query.page + 1}&per_page=${query.pageSize}&search=${query.search}`, config)
                                        .then(response => {
                                            let data = [];
                                            // eslint-disable-next-line
                                            response.data.data.map((row) => {
                                                data.push({
                                                    id: row.id,
                                                    subject: !!row.subject ? row.subject.length> 20 ? row.subject.slice(0,20)+"..." : row.subject : '',
                                                    receiver: row.receiver.first_name + " " + row.receiver.last_name,
                                                    starter: row.starter.first_name + " " + row.starter.last_name,
                                                    type: row.type,
                                                    target: row.type === "system" ? row.department : row.order_item,
                                                    priority: Translate[row.priority],
                                                    lastUpdate:
                                                        <Typography>
                                                            {`${moment(row.updated_at).locale('fa').fromNow()}`}
                                                            <br/>
                                                            {`${moment(row.updated_at).locale('fa').format( 'HH:mm , YYYY/M/D')}`}
                                                        </Typography>
                                                })
                                            });
                                            resolve({
                                                data: data,
                                                page: response.data.current_page - 1,
                                                totalCount: response.data.total,
                                            })
                                        }).catch(error => {
                                        console.log(error.response)
                                    })
                                })
                            }
                            options={{
                                pageSize: TablePage,
                                pageSizeOptions: TableCount,
                            }}
                            editable={{
                                onRowDelete: oldData =>
                                    new Promise(resolve => {
                                        setTimeout(() => {
                                            resolve();
                                            this.onDelete(oldData.id);
                                            this.setState(prevState => {
                                                const data = [...prevState.data];
                                                data.splice(data.indexOf(oldData), 1);
                                                return {...prevState, data};
                                            });
                                        }, 600);
                                    }),
                            }}

                        />
                    </Container>
                }
            </>
        );
    }
}

const mstp = state => ({
    Translate: state.Translate,
    locale: state.locale,
    user: state.user,
});
export default withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(Tickets))));